function PillButton(props = {size: 'sm' | 'md' | 'lg'}) {
    let sizeClasses = '';

    switch(props.size) {
        case 'sm':
            sizeClasses = 'px-4 py-2 text-sm';
            break;
        case 'md':
            sizeClasses = 'px-7 py-3';
            break;
        case 'lg':
            sizeClasses = 'px-10 py-4';
            break;
        default:
            sizeClasses = 'px-7 py-3';
            break;
    }

    return (
        <button className={`rounded-full shadow-lg ${sizeClasses} text-white bg-logo-green hover:bg-logo-green-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-logo-green transition-color text-bold pointer-events-auto`} onClick={props.onClick}>{props.children}</button>
    );
}

export default PillButton;